<div class="viz-container" [attr.data-row-height]="height">
  <!-- TODO ADD: Run Failed State -->
  <!-- TODO ADD: Configuration Error State -->
  <div class="viz-header">{{ title }}</div>
  <div *ngIf="!renderModel$ || (renderModel$ | async) === null" class="loading">
    <div class="loading-icon"><capra-icon icon="icon-chart-area"></capra-icon></div>
    <div>
      Fetching your data<span class="loading-dots"
        ><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span
      >
    </div>
  </div>
  <ng-container *ngIf="renderModel$ && (renderModel$ | async) !== null">
    <mode-viz-renderer
      *ngIf="isVegasRender"
      [token]="token"
      [renderModel]="renderModel$ | async"
      [renderContext]="'report_viewer'"
      [encoding]="encoding"
      [format]="format"
      [fieldFormats]="fieldFormats"
      [fieldColors]="fieldColors"
      [facetSizes]="facetSizes"
      [drilldownEnabled]="true"
      [isWhiteLabel]="false"
      [isEmbedded]="false"
      [reportApiService]="reportApiService"
      (renderStart)="renderStart($vizToken)"
      (renderEnd)="renderEnd($event)"
      (chartAction)="dispatchAction()"
    ></mode-viz-renderer>
    <mode-big-value-renderer
      *ngIf="chartType === 'bigValue'"
      [token]="token"
      [renderModel]="renderModel$ | async"
      [renderContext]="'report'"
      [encoding]="encoding"
      [format]="format"
      [fieldFormats]="fieldFormats"
      (render-start)="renderStart($vizToken)"
      (renderEnd)="renderEnd($event)"
      [maxFontSize]="maxFontSize$ | async"
    ></mode-big-value-renderer>
    <mode-table-renderer
      *ngIf="chartType === 'table'"
      class="table-renderer"
      [model]="modeModel$ | async"
      [queryToken]="queryToken$ | async"
      [token]="token"
      [columns]="(renderModel$ | async)?.columns"
      [content]="(renderModel$ | async)?.content"
      [paging]="(renderModel$ | async)?.paging"
      [encoding]="encoding"
      [fieldFormats]="fieldFormats"
      [format]="format"
      [autoHeight]="autoHeight"
      (setOffset)="setOffset($event)"
      (setTableColumnSearch)="setTableColumnSearch($event)"
      (update-encoding)="updateEncoding($event)"
      (render-start)="renderStart($vizToken)"
      (renderEnd)="renderEnd($event)"
    ></mode-table-renderer>
  </ng-container>
</div>
